module.exports = __webpack_public_path__ + "static/media/mw-2mass.7fb53ffd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/mw-2mass.jpg
// module id = 997
// module chunks = 0